import { Component, Inject, PLATFORM_ID, OnInit, OnDestroy } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-categorias',
    standalone: true,
    imports: [CommonModule, FormsModule],
    templateUrl: './categorias.component.html',
    styleUrls: ['./categorias.component.css']
})
export class CategoriasComponent implements OnInit, OnDestroy {
    idiomaSeleccionado: 'es' | 'en' = 'es';
    esMovil = false;
    private resizeListener!: () => void;

    categorias = {
        es: ['Fantasía', 'Acción', 'Romance', 'Terror', 'Cotidiano', 'Comedia', 'Deporte', 'Ciencia Ficción', 'Suspenso', 'Otros'],
        en: ['Fantasy', 'Action', 'Romance', 'Horror', 'Slice of Life', 'Comedy', 'Sports', 'Sci-Fi', 'Thriller', 'Others']
    };

    categoriaSeleccionada: string = this.categorias['es'][0];

    mangas = [
        { titulo: "Don't Revenge", autor: "Jarson34", imagen: "https://www.britishmuseum.org/sites/default/files/styles/uncropped_huge/public/2022-08/Manga-Golden-Kamuy-692x1024.jpg?itok=htog_9E3" },
        { titulo: "El Príncipe en el Jardín", autor: "Colfeshere & Liliwood", imagen: "https://static1.cbrimages.com/wordpress/wp-content/uploads/2022/11/10-Most-Successful-Manga-Ever-(-How-Many-Copies-Were-Sold).jpg" },
        { titulo: "Arnoldo y Amalia", autor: "Akuarello", imagen: "https://img.freepik.com/vector-gratis/ilustracion-colorear-paginas-anime_23-2151298326.jpg" },
        { titulo: "WARI", autor: "Elban", imagen: "https://dthezntil550i.cloudfront.net/ur/latest/ur2501042348007630005558604/ad4704e1-d2b3-4ffa-8297-2ab9f5a056f4_t.jpg" },
        { titulo: "PERSONAJE", autor: "Saikominc", imagen: "https://www.normaeditorial.com/upload/media/albumes/0001/36/thumb_35047_albumes_medium.jpeg" },
    ];

    constructor(@Inject(PLATFORM_ID) private platformId: object) {}

    ngOnInit() {
        if (isPlatformBrowser(this.platformId)) {
            this.detectarMovil();
            console.log('Idioma seleccionado:', this.idiomaSeleccionado); // Depuración
            console.log('Categoría seleccionada:', this.categoriaSeleccionada); // Depuración

            this.resizeListener = () => {
                this.detectarMovil();
                console.log('Resize detectado. Es móvil:', this.esMovil); // Depuración
            };
            window.addEventListener('resize', this.resizeListener);
        }
    }

    ngOnDestroy() {
        if (isPlatformBrowser(this.platformId)) {
            window.removeEventListener('resize', this.resizeListener);
        }
    }

    seleccionarCategoria(categoria: string) {
        this.categoriaSeleccionada = categoria;
    }

    cambiarIdioma(event: any) {
        this.idiomaSeleccionado = event.target.value as 'es' | 'en';
        this.categoriaSeleccionada = this.categorias[this.idiomaSeleccionado][0];
        console.log('Idioma cambiado a:', this.idiomaSeleccionado); // Depuración
        console.log('Categoría seleccionada:', this.categoriaSeleccionada); // Depuración
    }

    detectarMovil() {
        this.esMovil = window.innerWidth <= 768;
        console.log('Es móvil:', this.esMovil); // Depuración
    }
}